import { type Driver, isWebDataSuccess, type WebData } from '@cobliteam/api-lib';
import type { UUID, Vehicle, VehicleGroup } from '@cobliteam/common-types';
import { type AppState, loadDriversRequest, loadVehiclesRequest, selectDriversById, selectVehiclesById } from '@cobliteam/store';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import RoutesHistoryContainer from '../../containers/RoutesHistory';

interface OwnProps {
  onSwitchToV2?: () => void;
}

interface DispatchProps {
  loadPageContent: () => void;
}

interface StateProps {
  driversById: Map<UUID, Driver>;
  vehiclesById: Map<UUID, Vehicle>;
  vehicleGroupsById: Map<UUID, VehicleGroup>;
}

const valueOrEmpty = <T, U>(webData: WebData<Map<T, U>>): Map<T, U> => (isWebDataSuccess(webData) ? webData.data : new Map());

const emptyVehicleGroupsById = new Map<UUID, VehicleGroup>();

const mapStateToProps = (state: AppState): StateProps => ({
  driversById: valueOrEmpty(selectDriversById(state)),
  vehiclesById: valueOrEmpty(selectVehiclesById(state)),
  vehicleGroupsById: emptyVehicleGroupsById,
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  loadPageContent: () => {
    dispatch(loadDriversRequest());
    dispatch(loadVehiclesRequest());
  },
});

const TrackingHistoryPage = connect<StateProps, DispatchProps, OwnProps, AppState>(mapStateToProps, mapDispatchToProps)(RoutesHistoryContainer);

export default TrackingHistoryPage;
